<template>
  <div class="swiperslide">
    <div class="box">
      <div v-if="swiperList && swiperList.length > 1">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, index) in swiperList" :key="index">
            <div class="slider">
              <img
                @click="toLink(item)"
                :src="
                  item.url ? picAddr + item.url.replace('/upload/', '') : ''
                "
              />
            </div>
          </swiper-slide>
          <div
            class="swiper-pagination pagination"
            slot="pagination"
            style="cursor: pointer"
          >
            <div class="swiper-pagination-bullet"></div>
          </div>
        </swiper>
      </div>
      <div v-else-if="swiperList.length === 1 && swiperList[0]" class="slider">
        <div class="slider">
          <img
            @click="toLink(swiperList[0])"
            :src="
              swiperList[0].url
                ? picAddr + swiperList[0].url.replace('/upload/', '')
                : ''
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  props: ["swiperList"],
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
        paginationClickable: true,
        spaceBetween: 10,
        centeredSlides: true,
        autoplay: {
          delay: 5500,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        autoplayDisableOnInteraction: false,
      },
    };
  },
  methods: {
    toLink(item) {
      if (item.linkaddr) {
        window.location.href = item.linkaddr;
      }
    },
  },
  components: { swiper, swiperSlide },
  computed: {
    ...mapGetters(["picAddr"]),
  },
};
</script>

<style lang="scss">
@import "../../styles/variables.scss";
@media screen and (min-width: 1201px) {
  .swiperslide {
    .swiper-wrapper {
      width: 8000%;
      float: left;
    }
    .swiper-slide {
      float: left;
    }

    .box {
      width: 100%;
      overflow: hidden;
      position: relative;
      .slider {
        background-position: center;
        background-repeat: no-repeat;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .pagination {
        position: absolute;
        bottom: 20px;
        left: 0px;
        display: flex;
        width: 100%;
        justify-content: center;
        z-index: 3;
      }
      .swiper-pagination-bullet {
        background-color: rgba(255, 255, 255, 0.7);
        width: 9px;
        height: 9px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .swiper-pagination-bullet-active {
        background: $color-orange;
        width: 30px;
        border-radius: 4px;
        height: 9px;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .swiperslide {
    .swiper-wrapper {
      width: 8000%;
      float: left;
    }
    .swiper-slide {
      float: left;
    }

    .box {
      width: 100%;
      overflow: hidden;
      position: relative;
      .slider {
        background-position: center;
        background-repeat: no-repeat;
        height: 187px;
      width: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .pagination {
        position: absolute;
        bottom: 20px;
        left: 0px;
        display: flex;
        width: 100%;
        justify-content: center;
        z-index: 3;
      }
      .swiper-pagination-bullet {
        background-color: rgba(255, 255, 255, 0.7);
        width: 5px;
        height: 5px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .swiper-pagination-bullet-active {
        background: $color-orange;
        width: 15px;
        border-radius: 4px;
        height: 5px;
      }
    }
  }
}
</style>
